import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { isThemeGTE } from "../../../lib/theming/ThemeHelpers";
import { UploadIcon as TileUploadIcon } from "../icons/TileUploadIcon";
import { UploadIcon as RowUploadIcon } from "../icons/RowUploadIcon";
import { UploadIcon as DefaultUploadIcon } from "../icons/UploadIcon";
export var UploadIcon = function UploadIcon(props) {
  var theme = useContext(ThemeContext);
  var versionGTE5_5 = isThemeGTE(theme, '5.5');
  var size = props.size,
    _props$view = props.view,
    view = _props$view === void 0 ? 'row' : _props$view;
  if (versionGTE5_5) {
    return view === 'row' ? /*#__PURE__*/React.createElement(RowUploadIcon, {
      size: size
    }) : /*#__PURE__*/React.createElement(TileUploadIcon, {
      size: size
    });
  }
  return /*#__PURE__*/React.createElement(DefaultUploadIcon, {
    size: size
  });
};